<template>
    <div>
        点击编辑
    </div>
</template>

<script>
	export default {
		name: "ArrayButton",
		props: {
			data: {
				required: true
			}
		},
		methods: {
			getValue() {
				return this.data;
			}
		}
	}
</script>

<style scoped>

</style>